<template lang="pug">
  main
    NavBarSoporte
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title {{ title }} &nbsp
              i.fas.fa-ticket-alt
        .columns
          .column.is-offset-2.is-8
            CardTicket(:ticket="ticket")
        .columns.has-text-centered
          .column.is-offset-one-quarter.is-half
            a.button.is-black.is-rounded(@click="bakcPage")
              | Regresar
</template>


<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarSoporte from '@/components/soporte_Componentes/NavBarSoporte.vue'
import CardTicket from '@/components/soporte_Componentes/CardTicket.vue'
import { mapState } from 'vuex'
import InventarioServices from '@/services/inventario/inventario'
import ticketServices from '@/services/soporte/tickets'
import moment from 'moment'

  export default {
    name: 'DetalleTicket',
    components: { Loader, NavBarSoporte, CardTicket },
    data() {
      return {
        isLoading: true,
        title: '',
        ticket: {}
      }
    },
    methods: {
      iniciarComponente () {
        this.obtenerData()
      },
      obtenerData () {
        this.title = `Ticket ${this.ticketAtendido.id}`
        this.ticket = this.convetirTickets(this.ticketAtendido)
        this.isLoading = false
      },
      convetirTickets(ticket) {
        return {
          ...ticket,
          area: parseInt(ticket.area),
          departamento: parseInt(ticket.departamento),
          diagnostico: parseInt(ticket.diagnostico),
          estado: parseInt(ticket.estado),
          id: parseInt(ticket.id),
          restante: parseInt(ticket.restante),
          compra: parseInt(ticket.compra)
        }
      },
      bakcPage() {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'area_soporte', 'ticketAtendido'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/soporte_Componentes/DetalleTicket.vue